import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { CV } from "@/data/cv";

export default function Experience() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex((cur) => (cur === i ? null : i));

  return (
    <section id="werdegang" data-testid="experience-section" className="py-24 md:py-32 border-b-2 border-black">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12 md:mb-16">
          <div>
            <p className="font-mono-acc text-xs text-[#525252] mb-4">// 02 — Werdegang</p>
            <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
              Werde<span className="text-[#FF3B00]">gang.</span>
            </h2>
          </div>
          <p className="font-mono-acc text-[11px] md:text-xs text-[#525252] max-w-sm">
            Ein Klick auf eine Station zeigt die Details.
          </p>
        </div>

        <ol data-testid="experience-list" className="divide-y-2 divide-black border-y-2 border-black">
          {CV.experience.map((job, i) => {
            const isOpen = openIndex === i;
            return (
              <li
                key={`${job.company}-${i}`}
                data-testid={`experience-item-${i}`}
                className="group"
              >
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                  data-testid={`experience-toggle-${i}`}
                  className={`w-full text-left py-5 md:py-6 px-2 md:px-4 grid grid-cols-12 gap-4 items-baseline md:items-center transition-colors ${
                    isOpen ? "border-l-4 border-[#FF3B00] bg-white" : "hover:bg-white border-l-4 border-transparent"
                  }`}
                >
                  <span className="col-span-12 md:col-span-3 font-mono-acc text-[11px] text-[#525252]">
                    {job.period}
                  </span>
                  <span className="col-span-10 md:col-span-6 font-display uppercase text-xl md:text-2xl leading-tight">
                    {job.company}
                  </span>
                  <span className="col-span-12 md:col-span-2 text-sm md:text-[15px] text-[#525252] font-medium">
                    {job.role}
                  </span>
                  <span className="col-span-2 md:col-span-1 flex justify-end">
                    {isOpen ? (
                      <Minus className="w-5 h-5 text-[#FF3B00]" />
                    ) : (
                      <Plus className="w-5 h-5 text-[#0F0F0F]" />
                    )}
                  </span>
                </button>

                {isOpen && (
                  <div
                    data-testid={`experience-details-${i}`}
                    className="pb-6 md:pb-8 px-2 md:px-4 bg-white border-l-4 border-[#FF3B00]"
                  >
                    <div className="grid grid-cols-12 gap-4">
                      <div className="col-span-12 md:col-span-3" />
                      <div className="col-span-12 md:col-span-9">
                        {job.location && (
                          <p className="font-mono-acc text-[10px] text-[#525252] mb-3">
                            {job.location}
                          </p>
                        )}
                        <ul className="space-y-2 text-[15px] md:text-base leading-relaxed">
                          {job.bullets.map((b, j) => (
                            <li key={j} className="flex gap-3">
                              <span className="text-[#FF3B00] mt-1 shrink-0">—</span>
                              <span>{b}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
